import * as React from 'react';

import { theme } from '../../../../styles/2020/theme';

import { H2, P, Text } from '../../common/Primitives';
import { Column } from '../../layout/Column';
import { FullWidthBackground } from '../../layout/FullWidthBackground';
import { Grid } from '../../layout/Grid';

type TextGridBlockVariant = 'inherit' | 'dark' | 'beige';

type TextGridBlockProps = React.ComponentProps<typeof FullWidthBackground> & {
  title: string;
  variant?: TextGridBlockVariant;
  items: { title: string; text: string | React.ReactNode }[];
};

export function TextGridBlock({ title, variant = 'inherit', items }: TextGridBlockProps) {
  return (
    <FullWidthBackground
      forwardedAs="section"
      invertColors={variant === 'dark'}
      secondaryColor={variant === 'beige' ? theme.colors.beige : theme.colors.white}
      intrinsic={false}
    >
      <Column space={theme.space.l}>
        <H2>{title}</H2>
        <Grid>
          {items.map(({ title, text }) => (
            <Column key={title} space={theme.space.xxs}>
              <Text as="h3" size="m" bold>
                {title}
              </Text>
              {text && <P size="s">{text}</P>}
            </Column>
          ))}
        </Grid>
      </Column>
    </FullWidthBackground>
  );
}
